import { render, staticRenderFns } from "./EventListingWithFilters.vue?vue&type=template&id=d5c60e12&"
import script from "./EventListingWithFilters.vue?vue&type=script&lang=ts&"
export * from "./EventListingWithFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports